import React from "react";
import { IFilterState } from "./events";
import { Select, SelectOption } from "../elements/inputs/select";
import styled from "@emotion/styled";
import { EventResourceBundle } from "./event-filter.rb";

interface IKeyValue {
  id: string;
  value: string;
}

interface IEventFilterProps {
  eventTypes: IKeyValue[];
  cities: any[];
  filters: IFilterState;
  setFilters: (filters: Partial<IFilterState>) => void;
}

const StyledFilterContainer = styled.div`
  margin: 0 auto;
`;

const StyledFilterElement = styled.div`
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  transition: all 0.5s ease;
`;

export const EventFilter = ({
  eventTypes,
  cities,
  filters: { eventType, city, dateRange },
  setFilters,
}: IEventFilterProps) => {
  return (
    <StyledFilterContainer>
      <div className="row">
        <StyledFilterElement className="col-xs-12 col-sm-8 col-sm-offset-2 col-md-offset-2 col-md-4">
          <Select
            isSearchable={false}
            options={cities?.map((city) => ({
              label: city.value,
              value: city.id,
            }))}
            value={city}
            isClearable={true}
            placeholder={EventResourceBundle.placeholders.city}
            onChange={(city) => {
              if (!Array.isArray(city)) {
                setFilters({ city: city as SelectOption });
              }
            }}
          />
        </StyledFilterElement>
        <StyledFilterElement className="col-xs-12 col-sm-8 col-sm-offset-2 col-md-4 col-md-offset-0">
          <Select
            isSearchable={false}
            menuIsOpen={!city ? false : undefined}
            isDisabled={!city}
            options={eventTypes?.map((type) => ({
              label: type.value,
              value: type.id,
            }))}
            isMulti
            closeMenuOnSelect={false}
            value={eventType}
            isClearable={true}
            placeholder={EventResourceBundle.placeholders.eventType}
            onChange={(type) => {
              setFilters({ eventType: (type as SelectOption[]) || [] });
            }}
          />
        </StyledFilterElement>
      </div>
    </StyledFilterContainer>
  );
};
